import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { JSX, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

// import Icon from '../Icon/Icon';

import { normalizeOrderId } from '../../utils/normalizeOrderId';

import Icon from '../Icon/Icon';

import styles from './ActiveOrderCard.module.scss';
import { STATUS_INDICATORS } from './constants';
import { useEstimatedTime } from './hooks';
import { IActiveOrderCardProps } from './interfaces';

const ActiveOrderCard = (props: IActiveOrderCardProps): JSX.Element => {
  const { order, className } = props;
  const { t } = useTranslation();

  const normalizedOrderId = normalizeOrderId(order.order_id);

  const estimatedTime = useEstimatedTime(order);

  const progressPercent = useMemo(() => {
    const max = STATUS_INDICATORS.length + 1;
    const activeStatusIndex =
      STATUS_INDICATORS.indexOf(order.public_status) + 1;

    return Math.ceil((activeStatusIndex / max) * 100);
  }, [order]);

  return (
    <Link
      to={`/order/${order.id}`}
      className={classes([styles.deliveringWrapper, className])}
    >
      <div className={styles.blockOne}>
        <div className={styles.leftBlock}>
          <div className={styles.orderTitleWrapper}>
            <div className={styles.title}>
              {t('phrases:orderNum', { number: `#${normalizedOrderId}` })}
            </div>
            <div className={styles.track}>
              {STATUS_INDICATORS.map((status, idx) => {
                const isLast = idx >= STATUS_INDICATORS.length - 1;
                const orderStatusIndex = STATUS_INDICATORS.indexOf(
                  order.public_status,
                );

                return (
                  <div
                    key={status}
                    className={classes([
                      styles.point,
                      {
                        // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
                        [styles.passed]: idx > orderStatusIndex,
                        // @ts-expect-error FIXME: migrate to noUncheckedIndexedAccess: true
                        [styles.active]: status === order.public_status,
                      },
                    ])}
                  >
                    <div className={styles.icon} />
                    {!isLast && <div className={styles.line} />}
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.delivering}>
            {t(`orderStatus:${order.public_status}.value`)}
          </div>
        </div>
        <div className={styles.rightBlock}>
          <div className={styles.estimateWrapper}>
            <div className={styles.text}>
              <span>{t('phrases:estTimeOfDelivery')}</span>
              <span className={styles.short}>
                {t('phrases:estTimeOfDeliveryShort')}
              </span>
            </div>
            <div className={styles.time}>{estimatedTime}</div>
          </div>
        </div>
      </div>

      <div className={styles.blockTwo}>
        <div
          className={styles.progress}
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <Link to="/cabinet/referral" className={styles.inviteWrapper}>
        <div className={styles.referWrapper}>
          <Icon type="refferal" size={16} />
          <div className={styles.text}>{t('phrases:referFriend')}</div>
        </div>
      </Link>
    </Link>
  );
};

export default observer(ActiveOrderCard);
